import { useRef, useState, useEffect } from 'react';
import styles from './storyTimeline.module.scss';
//mui
import { Box, Stack, Typography, Slider, SliderThumb } from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from '@mui/lab';
import { styled } from '@mui/material/styles';

import Image from 'next/image';
import { useRouter } from 'next/router';

import {
  sufferingWithPain,
  findRelief,
  discoverReliefFactor,
  stressedOut,
  meditationPose,
  zenSuccess,
  noEnergy,
  twoEnergyDrinks,
  studying,
  sleepless,
  sleeping,
  rejuvenated,
} from '../../../src/images';

import { STORY_LOGO } from '../../../src/assets/images';

import imgLoader from '../../../imgloader';
import useMediaQuery from '@mui/material/useMediaQuery';

import { getDistanceBetweenElements } from '../../../utils/Utils';
import { useIsomorphicLayoutEffect } from '../../../commons/hooks';

function TimeLineSilderThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      <div style={{}}>
        <STORY_LOGO />
      </div>
    </SliderThumb>
  );
}
const ReliefFactorTitle = () => {
  return (
    <Typography
      variant="h1"
      component="span"
      color="primary.main"
      className={styles.noWrap}
    >
      &nbsp;&nbsp;&nbsp;&nbsp;Fight Pain.
      <Typography variant="h1" component="span" color="primary.light">
        {' '}
        Naturally.
      </Typography>
    </Typography>
  );
};

const ReliefFactor = ({
  isMobile,
  firstDot,
  secondDot,
  lastDot,
  StyledSlider,
  height,
}) => {
  return (
    <>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Box className={styles.timelineImg1}>
              <Image
                src={sufferingWithPain}
                layout="fill"
                loader={imgLoader}
                className={styles.timelineImg1Main}
                blurDataURL={sufferingWithPain}
                placeholder="blur"
              />
            </Box>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <div className={styles.rfLogoWapper}>
            <StyledSlider
              slots={{ thumb: TimeLineSilderThumbComponent }}
              orientation="vertical"
              value={(-height / 800) * 100 || 0}
              className={styles.timelineSlider}
            />
          </div>
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="firstDot"
            ref={firstDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Give Pain the Hurt
            </Typography>
            <Typography variant="p1">
              There are many ways to fight everyday pain. You can tough it out.
              You can sit it out. (That’s no fun.) And of course, you can try to
              mask it out. Temporarily. Or… you can fight back naturally, as
              over a million others have, with Relief Factor.{' '}
              <a className={styles.copyRightSymbol}>**</a>
            </Typography>
            {isMobile && (
              <Box className={styles.timelineImg1}>
                <Image
                  src={sufferingWithPain}
                  layout="fill"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={sufferingWithPain}
                  placeholder="blur"
                />
              </Box>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.evenContantContainer}`}
          >
            <Stack className={styles.timelineImg2Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={findRelief}
                  layout="fill"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={findRelief}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}
        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="secondDot"
            ref={secondDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.oddContentContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            {!isMobile && (
              <>
                <Typography variant="h3" color="primary.main">
                  Don’t mask the pain.{' '}
                  <span className={styles.noWrap}> Eliminate it</span>.
                </Typography>
                <Typography variant="p1">
                  Developed by a doctor with his own pain story, Relief Factor
                  is a 100% drug-free daily supplement. Unlike pills that just
                  mask pain temporarily, Relief Factor helps support your body’s
                  natural response to inflammation - reducing or even
                  eliminating pain, all day, every day.
                </Typography>
              </>
            )}

            {isMobile && (
              <>
                <Stack className={styles.timelineImg2Container}>
                  <Typography variant="h3" color="primary.main">
                    Don’t mask the pain.{' '}
                    <span className={styles.noWrap}> Eliminate it</span>.
                  </Typography>
                  <Typography variant="p1">
                    Developed by a doctor with his own pain story, Relief Factor
                    is a 100% drug-free daily supplement. Unlike pills that just
                    mask pain temporarily, Relief Factor helps support your
                    body’s natural response to inflammation - reducing or even
                    eliminating pain, all day, every day.
                  </Typography>
                  <Box className={styles.timelineImg1}>
                    <Image
                      src={findRelief}
                      layout="fill"
                      loader={imgLoader}
                      className={styles.timelineImg1Main}
                      blurDataURL={findRelief}
                      placeholder="blur"
                    />
                  </Box>
                </Stack>
              </>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Stack className={styles.timelineImg3Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={discoverReliefFactor}
                  layout="fill"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={discoverReliefFactor}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            ref={lastDot}
          />
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Help Your Body Help Itself
            </Typography>
            <Typography variant="p1">
              You may be able to keep YOUR pain away—all day, every day—with
              Relief Factor, a supplement that helps your body help itself. It’s
              a different approach to pain relief.*
            </Typography>
            {isMobile && (
              <Stack className={styles.timelineImg3Container}>
                <Box className={styles.timelineImg3}>
                  <Image
                    src={discoverReliefFactor}
                    layout="fill"
                    objectFit="cover"
                    loader={imgLoader}
                    className={styles.timelineImg3Main}
                    blurDataURL={discoverReliefFactor}
                    placeholder="blur"
                  />
                </Box>
              </Stack>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
    </>
  );
};

const ZenFactorNew = ({
  isMobile,
  firstDot,
  secondDot,
  lastDot,
  StyledSlider,
  height,
  pathName,
}) => {
  return (
    <>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Box className={styles.timelineImg1}>
              <Image
                src={stressedOut}
                layout="fill"
                loader={imgLoader}
                className={styles.timelineImg1Main}
                blurDataURL={stressedOut}
                placeholder="blur"
              />
            </Box>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <div className={styles.rfLogoWapper}>
            <StyledSlider
              slots={{ thumb: TimeLineSilderThumbComponent }}
              orientation="vertical"
              value={(-height / 800) * 100 || 0}
              className={styles.timelineSlider}
            />
          </div>
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="firstDot"
            ref={firstDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Diminish Stress,{' '}
              <span className={styles.noWrap}>Dissolve Anxiety</span>
            </Typography>
            <Typography variant="p1">
              In a world where anxiety swirls like a never-ending tempest,{' '}
              <span className={styles.noWrap}>Zen Factor</span> is nature's 100%
              drug-free antidote. Formulated and blended by doctors,{' '}
              <span className={styles.noWrap}>Zen Factor</span> can help you
              sail smoothly through the daily storms of life, turn chaos into
              serenity and navigate stress with poise.
              <a className={styles.copyRightSymbol}>**</a>
            </Typography>
            {isMobile && (
              <Box className={styles.timelineImg1}>
                <Image
                  src={stressedOut}
                  layout="fill"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={stressedOut}
                  placeholder="blur"
                />
              </Box>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.evenContantContainer}`}
          >
            <Stack className={styles.timelineImg2Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={meditationPose}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={meditationPose}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}
        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="secondDot"
            ref={secondDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.oddContentContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            {!isMobile && (
              <>
                <Typography variant="h3" color="primary.main">
                  Anxiety's Off-Switch
                </Typography>
                <Typography variant="p1">
                  Zen Factor supports your body's physiological response to
                  stress and anxiety. It calms racing thoughts, allowing your
                  mind to achieve its natural equilibrium and positivity. The
                  outcome can be a profound, deep-seated feeling of overall
                  wellness and heightened spirits.
                </Typography>
              </>
            )}

            {isMobile && (
              <>
                <Stack className={styles.timelineImg2Container}>
                  <Typography variant="h3" color="primary.main">
                    Anxiety's Off-Switch
                  </Typography>
                  <Typography variant="p1">
                    Zen Factor supports your body's physiological response to
                    stress and anxiety. It calms racing thoughts, allowing your
                    mind to achieve its natural equilibrium and positivity. The
                    outcome can be a profound, deep-seated feeling of overall
                    wellness and heightened spirits.
                  </Typography>
                  <Box className={styles.timelineImg1}>
                    <Image
                      src={meditationPose}
                      layout="fill"
                      loader={imgLoader}
                      className={styles.timelineImg1Main}
                      blurDataURL={meditationPose}
                      placeholder="blur"
                    />
                  </Box>
                </Stack>
              </>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Stack className={styles.timelineImg3Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={zenSuccess}
                  layout="fill"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={zenSuccess}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            ref={lastDot}
          />
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Zen In. Anxiety Out.
            </Typography>
            <Typography variant="p1">
              Amid life's daily demands, there's a serenity waiting to be
              embraced. With its nature-inspired blend{' '}
              <span className={styles.noWrap}>Zen Factor</span> can help quiet
              the noise and calm the mind.{' '}
              <span className={styles.noWrap}>Zen Factor</span> can be your
              answer to a more centered, peaceful, and joy-filled existence.
            </Typography>
            {isMobile && (
              <Stack className={styles.timelineImg3Container}>
                <Box className={styles.timelineImg3}>
                  <Image
                    src={zenSuccess}
                    layout="fill"
                    objectFit="cover"
                    loader={imgLoader}
                    className={styles.timelineImg3Main}
                    blurDataURL={zenSuccess}
                    placeholder="blur"
                  />
                </Box>
              </Stack>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
    </>
  );
};

const GoFactorNew = ({
  isMobile,
  firstDot,
  secondDot,
  lastDot,
  StyledSlider,
  height,
}) => {
  return (
    <>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Box className={styles.timelineImg1}>
              <Image
                src={noEnergy}
                layout="fill"
                loading="eager"
                className={styles.timelineImg1Main}
                blurDataURL={noEnergy}
                placeholder="blur"
              />
            </Box>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <div className={styles.rfLogoWapper}>
            <StyledSlider
              slots={{ thumb: TimeLineSilderThumbComponent }}
              orientation="vertical"
              value={(-height / 800) * 100 || 0}
              className={styles.timelineSlider}
            />
          </div>
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="firstDot"
            ref={firstDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              From Drained to Driven
            </Typography>
            <Typography variant="p1">
              In today's fast-paced world, staying energized and mentally sharp
              is crucial. Introducing{' '}
              <span className={styles.noWrap}> Go Factor</span>, a unique
              supplement blend designed to give you that much-needed boost, but
              with a difference. Unlike conventional energy enhancers,{' '}
              <span className={styles.noWrap}> Go Factor</span> ensures a smooth
              surge of vitality, ensuring you're not just awake but truly
              present. With <span className={styles.noWrap}> Go Factor</span>,
              you're not just consuming energy, you're embracing enhanced
              performance.
              <a className={styles.copyRightSymbol}>**</a>
            </Typography>
            {isMobile && (
              <Box className={styles.timelineImg1}>
                <Image
                  src={noEnergy}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={noEnergy}
                  placeholder="blur"
                />
              </Box>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.evenContantContainer}`}
          >
            <Stack className={styles.timelineImg2Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={twoEnergyDrinks}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={twoEnergyDrinks}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}
        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="secondDot"
            ref={secondDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.oddContentContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            {!isMobile && (
              <>
                <Typography variant="h3" color="primary.main">
                  Advantage Over{' '}
                  <span className={styles.noWrap}>Energy Drinks</span>
                </Typography>
                <Typography variant="p1">
                  <span className={styles.noWrap}> Go Factor</span> provides a
                  cost-effective and convenient alternative to energy drinks.
                  While energy drinks can be costly, large, and filled with
                  unnecessary calories and sugar,{' '}
                  <span className={styles.noWrap}> Go Factor</span> is available
                  in easy-to-take capsules. This ensures you can get the right
                  dose of energy without the extra calories, making it a
                  convenient and cost-effective fit for your day-to-day energy
                  needs.
                </Typography>
              </>
            )}

            {isMobile && (
              <>
                <Stack className={styles.timelineImg2Container}>
                  <Typography variant="h3" color="primary.main">
                    Advantage Over Energy Drinks
                  </Typography>
                  <Typography variant="p1">
                    <span className={styles.noWrap}> Go Factor</span> provides a
                    cost-effective and convenient alternative to energy drinks.
                    While energy drinks can be costly, large, and filled with
                    unnecessary calories and sugar,{' '}
                    <span className={styles.noWrap}> Go Factor</span> is
                    available in easy-to-take capsules. This ensures you can get
                    the right dose of energy without the extra calories, making
                    it a convenient and cost-effective fit for your day-to-day
                    energy needs.
                  </Typography>
                  <Box className={styles.timelineImg1}>
                    <Image
                      src={twoEnergyDrinks}
                      layout="fill"
                      loading="eager"
                      className={styles.timelineImg1Main}
                      blurDataURL={twoEnergyDrinks}
                      placeholder="blur"
                    />
                  </Box>
                </Stack>
              </>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Stack className={styles.timelineImg3Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={studying}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={studying}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            ref={lastDot}
          />
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Experience the Go Factor Advantage
            </Typography>
            <Typography variant="p1">
              Dive deep into the transformation that{' '}
              <span className={styles.noWrap}> Go Factor</span> can bring to
              your daily grind. Whether gearing up for an intense day at the
              office or pushing through those late-night endeavors,{' '}
              <span className={styles.noWrap}> Go Factor</span> can be your
              answer. Unlock your potential and enjoy sustained energy, without
              the jitters that come with ordinary stimulants. Embrace the{' '}
              <span className={styles.noWrap}> Go Factor</span> advantage.
            </Typography>
            {isMobile && (
              <Stack className={styles.timelineImg3Container}>
                <Box className={styles.timelineImg3}>
                  <Image
                    src={studying}
                    layout="fill"
                    loading="eager"
                    objectFit="cover"
                    loader={imgLoader}
                    className={styles.timelineImg3Main}
                    blurDataURL={studying}
                    placeholder="blur"
                  />
                </Box>
              </Stack>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
    </>
  );
};

const ZFactorNew = ({
  isMobile,
  firstDot,
  secondDot,
  lastDot,
  StyledSlider,
  height,
}) => {
  return (
    <>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Box className={styles.timelineImg1}>
              <Image
                src={sleepless}
                layout="fill"
                loading="eager"
                className={styles.timelineImg1Main}
                blurDataURL={sleepless}
                placeholder="blur"
              />
            </Box>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <div className={styles.rfLogoWapper}>
            <StyledSlider
              slots={{ thumb: TimeLineSilderThumbComponent }}
              orientation="vertical"
              value={(-height / 800) * 100 || 0}
              className={styles.timelineSlider}
            />
          </div>
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="firstDot"
            ref={firstDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Rise and Truly Shine
            </Typography>
            <Typography variant="p1">
              Z Factor goes beyond just melatonin. Crafted with precision by
              expert doctors, it stands as your completely drug-free partner for
              a tranquil night of rest. Infused with four specially chosen
              ingredients, <span className={styles.noWrap}>Z Factor</span> is
              tailored to softly guide your mind and body into deep,
              rejuvenating sleep. This deliberate blend not only aids in
              seamlessly drifting off to sleep but also ensures you wake up free
              from lingering drowsiness, ready to embrace the day with
              revitalized energy and clear-mindedness.
              <a className={styles.copyRightSymbol}>**</a>
            </Typography>
            {isMobile && (
              <Box className={styles.timelineImg1}>
                <Image
                  src={sleepless}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={sleepless}
                  placeholder="blur"
                />
              </Box>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.evenContantContainer}`}
          >
            <Stack className={styles.timelineImg2Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={sleeping}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={sleeping}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}
        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            id="secondDot"
            ref={secondDot}
          />
          {isMobile ? (
            <TimelineConnector className={styles.dottedConnector} />
          ) : (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.oddContentContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            {!isMobile && (
              <>
                <Typography variant="h3" color="primary.main">
                  Always On the Go,{' '}
                  <span className={styles.noWrap}>Rarely Rested</span>
                </Typography>
                <Typography variant="p1">
                  Our busy lives filled with screens, activities, and concerns,
                  can make great sleep hard to achieve. The light from our
                  phones and computers can disrupt our body's natural sleep
                  rhythm. Plus, thinking about work, family, friends, and all
                  the things we have to do can keep our minds spinning when we
                  would rather be sleeping.{' '}
                  <span className={styles.noWrap}>Z Factor</span> provides your
                  body the support it needs to address the issues that come with
                  the modern lifestyle.
                </Typography>
              </>
            )}

            {isMobile && (
              <>
                <Stack className={styles.timelineImg2Container}>
                  <Typography variant="h3" color="primary.main">
                    Always On the Go, Rarely Rested
                  </Typography>
                  <Typography variant="p1">
                    Our busy lives filled with screens, activities, and
                    concerns, can make great sleep hard to achieve. The light
                    from our phones and computers can disrupt our body's natural
                    sleep rhythm. Plus, thinking about work, family, friends,
                    and all the things we have to do can keep our minds spinning
                    when we would rather be sleeping.{' '}
                    <span className={styles.noWrap}>Z Factor</span> provides
                    your body the support it needs to address the issues that
                    come with the modern lifestyle.
                  </Typography>
                  <Box className={styles.timelineImg1}>
                    <Image
                      src={sleeping}
                      layout="fill"
                      loading="eager"
                      className={styles.timelineImg1Main}
                      blurDataURL={sleeping}
                      placeholder="blur"
                    />
                  </Box>
                </Stack>
              </>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem className={styles.timelineMainItem}>
        {!isMobile && (
          <TimelineOppositeContent
            className={`${styles.timelineOppositeContent} ${styles.oddContentContainer}`}
          >
            <Stack className={styles.timelineImg3Container}>
              <Box className={styles.timelineImg1}>
                <Image
                  src={rejuvenated}
                  layout="fill"
                  loading="eager"
                  loader={imgLoader}
                  className={styles.timelineImg1Main}
                  blurDataURL={rejuvenated}
                  placeholder="blur"
                />
              </Box>
            </Stack>
          </TimelineOppositeContent>
        )}

        <TimelineSeparator className={styles.timelineSeparator}>
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
          <TimelineDot
            color="primary"
            className={styles.timelineDot}
            ref={lastDot}
          />
          {!isMobile && (
            <TimelineConnector className={styles.tranparentConnector} />
          )}
        </TimelineSeparator>
        <TimelineContent
          className={`${styles.timelineContent} ${styles.evenContantContainer}`}
        >
          <Stack className={styles.timelineInnerContent}>
            <Typography variant="h3" color="primary.main">
              Imagine Waking Up Rejuvenated
            </Typography>
            <Typography variant="p1">
              Waking up after a splendid night's sleep is a tranquil and
              rejuvenating experience. Your mind greets the day with clarity,
              leisure, and optimism, while your body feels a renewed energy. The
              hours ahead appear not as a challenge but as an inviting
              adventure. As you traverse through the day, the thought of fatigue
              remains blissfully absent, liberating your thoughts from wishing
              for rest.
            </Typography>
            {isMobile && (
              <Stack className={styles.timelineImg3Container}>
                <Box className={styles.timelineImg3}>
                  <Image
                    src={rejuvenated}
                    layout="fill"
                    loading="eager"
                    objectFit="cover"
                    loader={imgLoader}
                    className={styles.timelineImg3Main}
                    blurDataURL={rejuvenated}
                    placeholder="blur"
                  />
                </Box>
              </Stack>
            )}
          </Stack>
        </TimelineContent>
      </TimelineItem>
    </>
  );
};

export default function StoryTimeline({ productType, id = '' }) {
  const isMobile = useMediaQuery('(max-width:523px)');
  const timelineRef = useRef(null);
  const firstDot = useRef(null);
  const secondDot = useRef(null);
  const lastDot = useRef(null);
  const router = useRouter();
  const [height, setHeight] = useState(100);
  const [timelineDotDistance, setTimelineDotDistance] = useState(300);

  useEffect(() => {
    const delay = 800;
    const timerId = setTimeout(() => {
      const distance = getDistanceBetweenElements(
        firstDot.current,
        lastDot.current
      );
      setTimelineDotDistance(distance);
    }, delay);
    return () => clearTimeout(timerId);
  }, []);

  const handleScroll = () => {
    setHeight(timelineRef.current?.getBoundingClientRect().y);
    secondDot.current.style.opacity = isMobile
      ? 1
      : (-timelineRef.current?.getBoundingClientRect().y / 400) * 100 > 55
        ? 1
        : 0.3;
    lastDot.current.style.opacity = isMobile ? 1 : 0.3;
  };

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const StyledSlider = styled(Slider)(() => ({
    'height': `${timelineDotDistance}px`,
    '& .MuiSlider-rail': {
      borderRight: '3px dotted #004152',
      background: 'transparent',
      opacity: 0.3,
    },
    '& .MuiSlider-track': {
      borderRight: '3px dotted #004152',
      borderLeft: 'none',
      background: 'transparent',
      transition: 'height .5s ease-out',
    },
    '& .MuiSlider-thumb': {
      background: '#fff',
      width: '0px',
      height: '23px',
      transform: 'rotate(180deg) translate(-50%, -50%)',
      borderRadius: 30,
      transition: 'all .2s ease-out',
    },
    '& .MuiSlider-thumb:hover': {
      boxShadow: 'none',
    },
  }));

  const ZenFactorTitle = () => {
    return (
      <Typography variant="h1" component="span" color="primary.main">
        Find Your
        <Typography variant="h1" component="span" color="primary.light">
          &nbsp; Zen.
        </Typography>
        &nbsp; <span className={styles.noWrap}>Change Your Life.</span>
      </Typography>
    );
  };

  const GoFactorTitle = () => {
    return (
      <Typography variant="h1" component="span" color="primary.main">
        Smooth, Convenient Energy
      </Typography>
    );
  };

  const ZFactorTitle = () => {
    return (
      <Typography variant="h1" component="span" color="primary.main">
        Good Night.
        <Typography variant="h1" component="span" color="primary.light">
          {' '}
        </Typography>
        <span className={styles.noWrap}>Good Day.</span>
      </Typography>
    );
  };

  return (
    <Box className={styles.baseContainer} id={id}>
      <Box className={styles.background}></Box>
      <Stack className={styles.container}>
        <Box className={styles.titleContent}>
          {productType == 'REL' && <ReliefFactorTitle />}
          {productType == 'ZEN' && <ZenFactorTitle />}
          {productType == 'GOF' && <GoFactorTitle />}
          {productType == 'ZFA' && <ZFactorTitle />}
        </Box>
        <Box className={styles.timelineContent}>
          <Timeline
            position={isMobile ? 'right' : 'alternate'}
            className={styles.mainTimeline}
            ref={timelineRef}
          >
            {productType == 'REL' && (
              <ReliefFactor
                isMobile={isMobile}
                firstDot={firstDot}
                secondDot={secondDot}
                lastDot={lastDot}
                StyledSlider={StyledSlider}
                height={height}
                pathName={router.pathname}
              />
            )}
            {productType == 'ZEN' && (
              <ZenFactorNew
                isMobile={isMobile}
                firstDot={firstDot}
                secondDot={secondDot}
                lastDot={lastDot}
                StyledSlider={StyledSlider}
                height={height}
                pathName={router.pathname}
              />
            )}
            {productType == 'GOF' && (
              <GoFactorNew
                isMobile={isMobile}
                firstDot={firstDot}
                secondDot={secondDot}
                lastDot={lastDot}
                StyledSlider={StyledSlider}
                height={height}
                pathName={router.pathname}
              />
            )}
            {productType == 'ZFA' && (
              <ZFactorNew
                isMobile={isMobile}
                firstDot={firstDot}
                secondDot={secondDot}
                lastDot={lastDot}
                StyledSlider={StyledSlider}
                height={height}
                pathName={router.pathname}
              />
            )}
          </Timeline>
        </Box>
      </Stack>
      <Box className={styles.bottomBackground}></Box>
    </Box>
  );
}
